/**
 * Distinguish MM/DD/YYYY shape errors from impossible calendar dates (e.g. Feb 31)
 * when MUI DatePicker reports `invalidDate` for both cases.
 */

const SLASH_MDY_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

export function isSlashMdYShape(raw: string): boolean {
    return SLASH_MDY_PATTERN.test(raw.trim());
}

/** True when month/day/year form a real calendar date (rejects rollover/impossible days). */
export function isValidSlashMdYCalendarDate(raw: string): boolean {
    const m = raw.trim().match(SLASH_MDY_PATTERN);
    if (!m) return false;
    const month = parseInt(m[1], 10);
    const day = parseInt(m[2], 10);
    const year = parseInt(m[3], 10);
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;
    const d = new Date(year, month - 1, day);
    return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day;
}

export function invalidDatePickerUserMessage(
    rawInput: string,
    validationContext: 'dateOfBirth' | 'generic',
    t: (key: string) => string,
): string {
    const raw = rawInput.trim();
    const dob = validationContext === 'dateOfBirth';
    const shape = isSlashMdYShape(raw);
    const calendarOk = shape && isValidSlashMdYCalendarDate(raw);

    // If users type a month name (e.g. "feb 31"), this is not a "format" issue like "15-01-2000".
    // It should be treated as an "invalid date" to match user expectations.
    if (!shape && /[a-zA-Z]/.test(raw)) {
        return t(dob ? 'datePicker.dateOfBirth.invalid' : 'datePicker.generic.invalid');
    }

    if (shape && !calendarOk) {
        return t(dob ? 'datePicker.dateOfBirth.invalid' : 'datePicker.generic.invalid');
    }
    return t(dob ? 'datePicker.dateOfBirth.invalidFormat' : 'datePicker.generic.invalidFormat');
}
